/**
 * @class Base
 */
export default class Base {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  displayName
     * @param {Number}  density
     */
    constructor(id, name, displayName, density = 0) {
        this._id = id;
        this._name = name;
        this._displayName = displayName;
        this._density = density;
        this._baseInProductId = 0;
        this._baseInProductFillProc = 1;
        this._baseInProductUfi = null;
        this._key = displayName == null ? String(id) : displayName.replace(" ", "-");

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Base");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {Number}
     */
    get density() {
        return this._density;
    }

    /**
     * @param {Number} density
     */
    set density(density) {
        this._density = density;
    }

    /**
     * @return {Number}
     */
    get baseInProductId() {
        return this._baseInProductId;
    }

    /**
     * @param {Number} baseInProductId
     */
    set baseInProductId(baseInProductId) {
        this._baseInProductId = baseInProductId;
    }

    /**
     * @return {Number}
     */
    get baseInProductFillProc() {
        return this._baseInProductFillProc;
    }

    /**
     * @param {Number}  baseInProductFillProc
     */
    set baseInProductFillProc(baseInProductFillProc) {
        this._baseInProductFillProc = baseInProductFillProc;
    }

    /**
     * @return {String}
     */
    get baseInProductUfi() {
        return this._baseInProductUfi;
    }

    /**
     * @param {String}  baseInProductUfi
     */
    set baseInProductUfi(baseInProductUfi) {
        this._baseInProductUfi = baseInProductUfi;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Base (" + this._id + ")";
    }

    /**
     * @return {String}
     */
    getKey = () => {
        return this._key;
    };

    /**
     * @param   {Base}          base
     * @return  {String | null}
     */
    static serialize = (base) => {
        try {
            return (
                base.id +
                ";" +
                (base.name === null ? "null" : base.name.replace(/;/g, "")) +
                ";" +
                (base.displayName === null ? "null" : base.displayName.replace(/;/g, "")) +
                ";" +
                base.density
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * @param   {String | null} base
     * @return  {Base | null}
     */
    static unserialize = (base) => {
        if (typeof base !== "string") {
            return null;
        }

        let baseParts = base.split(";");

        if (baseParts.length !== 4) {
            return null;
        }

        try {
            return new Base(
                Number(baseParts[0]),
                baseParts[1] === "null" ? null : baseParts[1],
                baseParts[2] === "null" ? null : baseParts[2],
                Number(baseParts[3])
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * @return {Object}
     */
    formatedObject() {
        return {
            id: this._id,
            name: this._name,
            displayName: this._displayName,
            density: this._density,
            baseInProductId: this._baseInProductId,
            baseInProductFillProc: this._baseInProductFillProc,
            baseInProductUfi: this._baseInProductUfi,
            key: this._key
        };
    }
}
